import styled from '@emotion/styled';

const StyledCount = styled('span')(({ theme }) => ({
  color: theme.palette.text.secondary,
}));

type HiddenIndicatorsCountProps = {
  count: number;
};

const HiddenIndicatorsCount = ({ count }: HiddenIndicatorsCountProps) => (
  <StyledCount>+{count}</StyledCount>
);

export default HiddenIndicatorsCount;
